module.exports = __webpack_public_path__ + "static/media/lohono-infinity-home-image-md.79fd8257.svg";